<template>
    <footer class="page-footer">
        <div class="page-footer__page-container">
            <div class="page-footer__content-container">
                <div class="page-footer__grid">
                    <div class="page-footer__grid-column">
                        <ul class="page-footer__links">
                            <li>
                                <router-link to="/impressum">{{ t('imprint') }}</router-link>
                            </li>
                            <li>
                                <router-link to="/datenschutzrichtlinien">{{ t('privacy-policy') }}</router-link>
                            </li>
                            <li>
                                <router-link to="/compliance">{{ t('compliance') }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'PageFooter',

    computed: {
        ...mapGetters('uitexts', {
            isLoadingUiTexts: 'isLoading',
            t: 't',
        }),
    },

    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {


    },
}
</script>
